import React, { useState, useEffect, useRef } from "react";

import ClienteAutocomplete from "./ClienteAutocomplete";
import "./InterventoModal.css";
import { toast } from "react-toastify";
import { FaFileAlt, FaSave, FaTimes } from "react-icons/fa";

import RichTextDescriptionEditor from "./RichTextDescriptionEditor";
import PreventivoEmailSection from "./PreventivoEmailSection";
const API_URL = process.env.REACT_APP_API_URL || "https://interventi.synology.me:5050";
// BETALUMINA_COSTI_AGGIUNTIVI_DETTAGLIO_UI_R1
const emptyCostiAggiuntiviDettaglio = () => ({
  km: "",
  tariffaKm: "",
  oreViaggio: "",
  tariffaViaggio: "",
  pedaggi: "",
  parcheggi: "",
  spedizioni: "",
  noleggi: "",
  smaltimento: "",
  consumo: "",
  altroDescrizione: "",
  altroImporto: "",
});

const costoDettaglioNum = (v) => {
  const n = parseFloat(String(v ?? "").replace(",", "."));
  return Number.isFinite(n) ? n : 0;
};

const totaleCostiAggiuntiviDettaglio = (d) => {
  const x = d || {};
  return (
    costoDettaglioNum(x.km) * costoDettaglioNum(x.tariffaKm) +
    costoDettaglioNum(x.oreViaggio) * costoDettaglioNum(x.tariffaViaggio) +
    costoDettaglioNum(x.pedaggi) +
    costoDettaglioNum(x.parcheggi) +
    costoDettaglioNum(x.spedizioni) +
    costoDettaglioNum(x.noleggi) +
    costoDettaglioNum(x.smaltimento) +
    costoDettaglioNum(x.consumo) +
    costoDettaglioNum(x.altroImporto)
  );
};

const parseCostiAggiuntiviDettaglio = (raw, legacyTotale = 0) => {
  let parsed = {};
  try {
    parsed = typeof raw === "string" && raw.trim() ? JSON.parse(raw) : (raw || {});
  } catch (_) {
    parsed = {};
  }
  const base = { ...emptyCostiAggiuntiviDettaglio(), ...(parsed || {}) };
  const hasDetail = Object.entries(base).some(([k, v]) =>
    k === "altroDescrizione" ? String(v || "").trim() : costoDettaglioNum(v) > 0
  );
  if (!hasDetail && costoDettaglioNum(legacyTotale) > 0) {
    base.altroDescrizione = "Altri costi";
    base.altroImporto = String(costoDettaglioNum(legacyTotale));
  }
  return base;
};


const PreventivoModal = ({
  isOpen = false,
  onClose = () => {},
  onSave = () => {},
  selectedPreventivo = null,
  modalMode = "create",
  handleDownloadPDF = () => {},
  isLoading = false,
}) => {
  const [cliente, setCliente] = useState("");
  // BETALUMINA_TITOLO_CLIENTE_SIG_SIGRA_FIX22_FRONT_20261018
  const [titoloCliente, setTitoloCliente] = useState("");
  const [indirizzo, setIndirizzo] = useState("");
  const [email, setEmail] = useState("");
  const [telefono, setTelefono] = useState("");
  const [codiceFiscale, setCodiceFiscale] = useState("");
  const [partitaIva, setPartitaIva] = useState("");
  // BETALUMINA_PREVENTIVI_AUTOCOMPLETE_CLIENTE_FIX1
  const [clienteId, setClienteId] = useState(null);
  const [sitiCliente, setSitiCliente] = useState([]);
  const [sitoClienteId, setSitoClienteId] = useState("");

  useEffect(() => {
    let annullato = false;

    const caricaSitiCliente = async () => {
      if (!clienteId) {
        setSitiCliente([]);
        setSitoClienteId("");
        return;
      }

      try {
        const token = localStorage.getItem("token");
        const response = await fetch(
          `https://interventi.synology.me:5050/api/portal-admin/clienti/${clienteId}/siti`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        const data = await response.json().catch(() => []);
        if (!response.ok || annullato) return;

        const attivi = Array.isArray(data)
          ? data.filter((s) => Number(s.attivo) === 1)
          : [];

        setSitiCliente(attivi);

        const currentAddress = String(indirizzo || "").trim().toLowerCase();
        const match = attivi.find(
          (s) => String(s.indirizzo || "").trim().toLowerCase() === currentAddress
        );

        if (match) {
          setSitoClienteId(String(match.id));
        } else if (attivi.length === 1 && !currentAddress) {
          setSitoClienteId(String(attivi[0].id));
          setIndirizzo(attivi[0].indirizzo || "");
        }
      } catch (_) {
        if (!annullato) setSitiCliente([]);
      }
    };

    caricaSitiCliente();
    return () => { annullato = true; };
  }, [clienteId]);


  const [dataEmissione, setDataEmissione] = useState(
    new Date().toLocaleDateString("fr-CA")
  );
  const [validita, setValidita] = useState("30");
  // BETALUMINA_PREVENTIVI_SCADENZA_PRECISA_FRONT_FIX12_20261011
  const [dataScadenza, setDataScadenza] = useState("");

  const normalizeDateInputValue = (value) => {
    if (!value) return "";
    const raw = String(value);
    if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;

    const parsed = new Date(value);
    if (!Number.isNaN(parsed.getTime())) {
      return parsed.toLocaleDateString("fr-CA");
    }

    const match = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
    return match ? `${match[1]}-${match[2]}-${match[3]}` : "";
  };
  const [oggetto, setOggetto] = useState("");
  const [descrizione, setDescrizione] = useState("");
  // BETALUMINA_PREVENTIVI_RICH_DESCRIPTION_FRONT_FIX18D_20261017
  const [descrizioneRich, setDescrizioneRich] = useState("");
  const [costoMateriali, setCostoMateriali] = useState(0);
  // BETALUMINA_PREVENTIVI_MATERIALI_A_CORPO_FRONT_FIX13D_20261011
  const [materialiPrezzoACorpo, setMaterialiPrezzoACorpo] = useState(false);
  const [prezzoMaterialiManuale, setPrezzoMaterialiManuale] = useState("");
  const [costoManodopera, setCostoManodopera] = useState(0);
  const [oreLavoro, setOreLavoro] = useState(0);
  const [costoOrario, setCostoOrario] = useState(0);
  const [costiAggiuntivi, setCostiAggiuntivi] = useState(0);
  const [costiAggiuntiviDettaglio, setCostiAggiuntiviDettaglio] = useState(emptyCostiAggiuntiviDettaglio());
  const [costoTotale, setCostoTotale] = useState(0);
  const [costoTotaleSenzaSconto, setCostoTotaleSenzaSconto] = useState(0);
  const [ivaPercentuale, setIvaPercentuale] = useState(22);
  const [costoTotaleConIva, setCostoTotaleConIva] = useState(0);
  const [scontoPercentuale, setScontoPercentuale] = useState(0);
  const [scontoImporto, setScontoImporto] = useState(0);
  const [tipoSconto, setTipoSconto] = useState("percentuale");
  const [condizioniPagamento, setCondizioniPagamento] = useState("");
  const [tempiEsecuzione, setTempiEsecuzione] = useState("");
  const [garanzia, setGaranzia] = useState("");
  const [presetCondizioni, setPresetCondizioni] = useState("");
  const [note, setNote] = useState("");
  const [stato, setStato] = useState("Da fare");

  // materiali inclusi nel preventivo
  const [materiali, setMateriali] = useState([]);

  // materiali opzionali (fuori preventivo)
  const [materialiOpzionali, setMaterialiOpzionali] = useState([]);
  const [materialeOpzionaleSelezionato, setMaterialeOpzionaleSelezionato] = useState(null);
  const [quantitaMaterialeOpzionale, setQuantitaMaterialeOpzionale] = useState(1);
  const [gruppoMaterialeOpzionale, setGruppoMaterialeOpzionale] = useState("");
  const [stornoMaterialeOpzionale, setStornoMaterialeOpzionale] = useState(0);
  const [materialiOpzionaliSelezionatiMultipli, setMaterialiOpzionaliSelezionatiMultipli] = useState({});

  const [allegati, setAllegati] = useState([]);
  const [materialiDisponibili, setMaterialiDisponibili] = useState([]);
  const [materialeSelezionato, setMaterialeSelezionato] = useState(null);
  const [editingMaterialeIndex, setEditingMaterialeIndex] = useState(null);
  const [quantitaMateriale, setQuantitaMateriale] = useState(0);
  const [searchMateriale, setSearchMateriale] = useState("");
  const [materialiSelezionatiMultipli, setMaterialiSelezionatiMultipli] = useState({});

  const [isDirty, setIsDirty] = useState(false);
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [escludiIva, setEscludiIva] = useState(false);
  const [ivaSoloMateriali, setIvaSoloMateriali] = useState(false);
  // BETALUMINA_PREVENTIVI_ROUND_DOWN_FRONT_FIX17B_20261017
  const [arrotondaTotaleDifetto, setArrotondaTotaleDifetto] = useState(true);
  const [arrotondamentoCommerciale, setArrotondamentoCommerciale] = useState(0);
  const [materialiIvati, setMaterialiIvati] = useState(false);
  const quantitaInputRef = useRef(null);


  const getPrezzoMateriale = (materiale) => {
  if (!materiale) return 0;

  if (materialiIvati) {
    return parseFloat(
      materiale.prezzoConIva ?? materiale.costoUnitario ?? 0
    ) || 0;
  }

  return parseFloat(
    materiale.prezzoSenzaIva ?? materiale.costoUnitario ?? 0
  ) || 0;
};

  // === OPZIONALI: ricerca controllata + selezione compatta ===
  const [searchMaterialeOpzionale, setSearchMaterialeOpzionale] = useState("");

  const normalizzaRicercaMaterialeOpzionale = (value) =>
    String(value ?? "")
      .normalize("NFD")
      .replace(/[\\u0300-\\u036f]/g, "")
      .toLowerCase()
      .trim();

  const selezionaMaterialeOpzionale = (selectedId) => {
    const id = parseInt(selectedId, 10);
    const materiale = materialiDisponibili.find((m) => m.id === id);

    if (!materiale) {
      setMaterialeOpzionaleSelezionato(null);
      setQuantitaMaterialeOpzionale(0);
      return;
    }

    const costoUnitario = getPrezzoMateriale(materiale);
    setMaterialeOpzionaleSelezionato({
      ...materiale,
      costoUnitario: costoUnitario.toFixed(2),
    });
    setQuantitaMaterialeOpzionale(1);
    setSearchMaterialeOpzionale(
      `${materiale.codiceMateriale || ""} - ${materiale.descrizioneMateriale || ""}`.trim()
    );
  };

  const queryMaterialeOpzionale = normalizzaRicercaMaterialeOpzionale(
    searchMaterialeOpzionale
  );

  const materialiOpzionaliFiltrati =
    queryMaterialeOpzionale.length >= 2
      ? materialiDisponibili
          .filter((m) => {
            const haystack = normalizzaRicercaMaterialeOpzionale(
              [
                m.codiceMateriale,
                m.descrizioneMateriale,
                m.categoria,
              ]
                .filter(Boolean)
                .join(" ")
            );
            return haystack.includes(queryMaterialeOpzionale);
          })
          .sort((a, b) => {
            const catA = String(a.categoria || "");
            const catB = String(b.categoria || "");
            const byCategory = catA.localeCompare(catB, "it", {
              sensitivity: "base",
            });
            if (byCategory !== 0) return byCategory;

            return String(a.codiceMateriale || "").localeCompare(
              String(b.codiceMateriale || ""),
              "it",
              { sensitivity: "base" }
            );
          })
      : [];

  // BETALUMINA_OPTIONAL_MULTISELECT_R2
  const normalizzaRicercaOpzionaleR2 = (value) =>
    String(value ?? "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim();

  const queryOpzionaleR2 = normalizzaRicercaOpzionaleR2(searchMaterialeOpzionale);

  const materialiOpzionaliRisultatiR2 =
    queryOpzionaleR2.length >= 2
      ? materialiDisponibili
          .filter((m) => {
            const haystack = normalizzaRicercaOpzionaleR2(
              [m.codiceMateriale, m.descrizioneMateriale, m.categoria]
                .filter(Boolean)
                .join(" ")
            );
            return haystack.includes(queryOpzionaleR2);
          })
          .sort((a, b) => {
            const ca = String(a.categoria || "");
            const cb = String(b.categoria || "");
            const c = ca.localeCompare(cb, "it", { sensitivity: "base" });
            if (c !== 0) return c;
            return String(a.codiceMateriale || "").localeCompare(
              String(b.codiceMateriale || ""),
              "it",
              { sensitivity: "base" }
            );
          })
      : [];

  const toggleMaterialeOpzionaleR2 = (materiale) => {
    const id = String(materiale.id);
    setMaterialiOpzionaliSelezionatiMultipli((prev) => {
      const next = { ...prev };
      if (Object.prototype.hasOwnProperty.call(next, id)) {
        delete next[id];
      } else {
        next[id] = 1;
      }
      return next;
    });
  };

  const aggiornaQuantitaMaterialeOpzionaleR2 = (id, value) => {
    const qta = Math.max(1, parseInt(value, 10) || 1);
    setMaterialiOpzionaliSelezionatiMultipli((prev) => ({
      ...prev,
      [String(id)]: qta,
    }));
  };

  const handleAddMaterialiOpzionaliMultipliR2 = () => {
    const selezionati = Object.entries(materialiOpzionaliSelezionatiMultipli);

    if (selezionati.length === 0) {
      toast.error("Seleziona almeno un materiale opzionale");
      return;
    }

    const esistenti = new Set(
      materialiOpzionali.map(
        (m) => `${m.codiceMateriale || ""}|||${m.descrizioneMateriale || ""}`
      )
    );

    const nuovi = [];
    let duplicati = 0;

    selezionati.forEach(([id, qtaRaw]) => {
      const materiale = materialiDisponibili.find(
        (m) => String(m.id) === String(id)
      );
      if (!materiale) return;

      const chiave = `${materiale.codiceMateriale || ""}|||${materiale.descrizioneMateriale || ""}`;
      if (esistenti.has(chiave)) {
        duplicati += 1;
        return;
      }

      const qta = Math.max(1, parseInt(qtaRaw, 10) || 1);
      const costoUnitario = getPrezzoMateriale(materiale);

      nuovi.push({
        codiceMateriale: materiale.codiceMateriale,
        descrizioneMateriale: materiale.descrizioneMateriale,
        quantita: qta,
        costoUnitario,
        costoTotaleMateriale: (qta * costoUnitario).toFixed(2),
        thumbnail: materiale.thumbnail || null,
        opzioneGruppo: gruppoMaterialeOpzionale.trim(),
        opzioneStorno: parseFloat(stornoMaterialeOpzionale) || 0,
      });

      esistenti.add(chiave);
    });

    if (nuovi.length === 0) {
      toast.warn("I materiali selezionati sono già presenti tra gli opzionali.");
      setMaterialiOpzionaliSelezionatiMultipli({});
      return;
    }

    setMaterialiOpzionali((prev) => [...prev, ...nuovi]);
    setMaterialiOpzionaliSelezionatiMultipli({});
    setSearchMaterialeOpzionale("");
    setMaterialeOpzionaleSelezionato(null);
    setQuantitaMaterialeOpzionale(1);
    setIsDirty(true);

    toast.success(
      duplicati > 0
        ? `${nuovi.length} materiali opzionali aggiunti; ${duplicati} già presenti ignorati.`
        : `${nuovi.length} ${nuovi.length === 1 ? "materiale opzionale aggiunto" : "materiali opzionali aggiunti"}`
    );
  };

  // --- tracker cambi materiali ---
  const serializeMaterials = (arr) =>
    JSON.stringify(
      (arr || []).map(
        ({ codiceMateriale, descrizioneMateriale, quantita, costoUnitario, is_aggiuntivo, opzioneGruppo, opzioneStorno }) => ({
          codiceMateriale: codiceMateriale || "",
          descrizioneMateriale: descrizioneMateriale || "",
          quantita: Number(quantita) || 0,
          costoUnitario: Number(costoUnitario) || 0,
          is_aggiuntivo: is_aggiuntivo ? 1 : 0,
          opzioneGruppo: (opzioneGruppo || "").trim(),
          opzioneStorno: Number(opzioneStorno) || 0,
        })
      )
    );
  const initialMaterialsSnapshotRef = useRef("");

  // helpers
  const toBool = (v) => {
    if (v === null || v === undefined) return false;
    if (typeof v === "boolean") return v;
    if (typeof v === "number") return v === 1;
    const s = String(v).trim().toLowerCase();
    return s === "1" || s === "true" || s === "on" || s === "si" || s === "sì" || s === "yes";
  };
  const toFlag = (b) => (b ? 1 : 0);

  const normalizeText = (text) => {
  if (text === null || text === undefined) return "";

  return String(text)
    .normalize("NFC")
    .replace(/\u00A0/g, " ")
    .replace(/\r\n/g, "\n")
    .replace(/\r/g, "\n")
    .replace(/[\u0000-\u0008\u000B-\u000C\u000E-\u001F\u007F]/g, "")
    .replace(/[“”«»]/g, '"')
    .replace(/[‘’]/g, "'")
    .replace(/[‐-‒–—]/g, "-")
    .replace(/\t/g, "    ")
    .trim();
};

  const fetchPreventivoMateriali = async (preventivoId) => {
    setIsLoadingModal(true);
    try {
      const response = await fetch(`${API_URL}/preventivi/${preventivoId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      if (!response.ok) throw new Error("Errore nel recupero del preventivo");
      const data = await response.json();
      console.log("📄 Dati grezzi dal backend:", data);

      setCliente(data.cliente || "");
      setTitoloCliente(data.titoloCliente || "");
      setClienteId(data.cliente_id || null);
      setSitoClienteId(data.sito_id ? String(data.sito_id) : "");
      setIndirizzo(data.indirizzo || "");
      setEmail(data.email || "");
      setTelefono(data.telefono || "");
      setCodiceFiscale(data.codiceFiscale || "");
      setPartitaIva(data.partitaIva || "");
      setDataEmissione(
        data.dataEmissione
          ? new Date(data.dataEmissione).toLocaleDateString("fr-CA")
          : new Date().toLocaleDateString("fr-CA")
      );
      setValidita(data.validita || "30");
        setDataScadenza(normalizeDateInputValue(data.dataScadenza));
      setOggetto(data.oggetto || "");
      setDescrizione(data.descrizione || "");
        setDescrizioneRich(data.descrizioneRich || "");
      setOreLavoro(parseFloat(data.oreLavoro) || 0);
      setCostoOrario(parseFloat(data.costoOrario) || 0);
      const costiDettaglioCaricati = parseCostiAggiuntiviDettaglio(
        data.costiAggiuntiviDettaglio,
        parseFloat(data.costiAggiuntivi) || 0
      );
      setCostiAggiuntiviDettaglio(costiDettaglioCaricati);
      setCostiAggiuntivi(Number(totaleCostiAggiuntiviDettaglio(costiDettaglioCaricati).toFixed(2)));
      setIvaPercentuale(parseFloat(data.ivaPercentuale) || 22);
      setCostoTotaleConIva(parseFloat(data.costoTotaleConIva) || 0);
      setScontoPercentuale(parseFloat(data.scontoPercentuale) || 0);
      setScontoImporto(parseFloat(data.scontoImporto) || 0);
      setCondizioniPagamento(data.condizioniPagamento || "");
      setTempiEsecuzione(data.tempiEsecuzione || "");
      setGaranzia(data.garanzia || "");
      setNote(data.note || "");
      setStato(data.stato || "Da fare");
      setEscludiIva(toBool(data.escludiIva));
      setIvaSoloMateriali(toBool(data.ivaSoloMateriali));
        setArrotondaTotaleDifetto(
          data.arrotondaTotaleDifetto === undefined ||
          data.arrotondaTotaleDifetto === null
            ? true
            : toBool(data.arrotondaTotaleDifetto)
        );
        const bodyModeLoaded = toBool(data.materialiPrezzoACorpo);
        const manualBodyLoaded =
          data.prezzoMaterialiManuale === null ||
          data.prezzoMaterialiManuale === undefined
            ? ""
            : String(data.prezzoMaterialiManuale);

        setMaterialiPrezzoACorpo(bodyModeLoaded);
        setPrezzoMaterialiManuale(manualBodyLoaded);
      // BETALUMINA_PREVENTIVI_ALLEGATI_FORM_FIX5_20260928
      setAllegati(Array.isArray(data.allegati) ? data.allegati : []);

      // ===== MATERIALI UFFICIALI + OPZIONALI DAL BACKEND =====
      const isAgg = (v) =>
        v === 1 || v === "1" || v === true || String(v).toLowerCase() === "true";

      const all = Array.isArray(data.materiali) ? data.materiali : [];
      const extra = Array.isArray(data.materialiAggiuntivi) ? data.materialiAggiuntivi : [];

      const ufficialiSrc = all.filter((m) => !isAgg(m.is_aggiuntivo));
      const aggiuntiviSrc = extra.length ? extra : all.filter((m) => isAgg(m.is_aggiuntivo));

      const mapRow = (m) => {
  const prezzo = parseFloat(m.costoUnitario ?? 0) || 0;
  const qta = parseInt(m.quantita, 10) || 0;
  return {
    codiceMateriale: m.codiceMateriale || "",
    descrizioneMateriale: m.descrizioneMateriale || m.descrizione || "",
    quantita: qta,
    costoUnitario: prezzo.toFixed(2),
    costoTotaleMateriale: (qta * prezzo).toFixed(2),
    thumbnail: m.thumbnail || null,
    is_aggiuntivo: isAgg(m.is_aggiuntivo) ? 1 : 0,
    opzioneGruppo: String(m.opzioneGruppo ?? m.opzione_gruppo ?? "").trim(),
    opzioneStorno: parseFloat(m.opzioneStorno ?? m.opzione_storno ?? 0) || 0,
  };
};

      const mappedUfficiali = ufficialiSrc.map(mapRow);
      const mappedAggiuntivi = aggiuntiviSrc.map(mapRow);

      setMateriali(mappedUfficiali);
      setMaterialiOpzionali(mappedAggiuntivi);
      if (bodyModeLoaded) {
        const manualLoaded = Number.parseFloat(
          String(manualBodyLoaded || "").replace(",", ".")
        );
        setCostoMateriali(Number.isFinite(manualLoaded) ? manualLoaded : 0);
      } else {
        aggiornaCostoMateriali(mappedUfficiali);
      }

      // 🔒 snapshot iniziale (QUI dentro lo scope giusto)
      const snap = serializeMaterials([
        ...mappedUfficiali.map((m) => ({ ...m, is_aggiuntivo: 0 })),
        ...mappedAggiuntivi.map((m) => ({ ...m, is_aggiuntivo: 1 })),
      ]);
      initialMaterialsSnapshotRef.current = snap;
      setIsDirty(false);
    } catch (error) {
      console.error("❌ Errore nel recupero del preventivo:", error);
      toast.error("Errore nel caricamento del preventivo!");
    } finally {
      setIsLoadingModal(false);
    }
  };

  // 🔔 Marca dirty se cambiano materiali/opzionali e aggiorna totale materiali
  useEffect(() => {
    const currentSnap = serializeMaterials([
      ...materiali.map((m) => ({ ...m, is_aggiuntivo: 0 })),
      ...materialiOpzionali.map((m) => ({ ...m, is_aggiuntivo: 1 })),
    ]);
    if (initialMaterialsSnapshotRef.current && currentSnap !== initialMaterialsSnapshotRef.current) {
      setIsDirty(true);
      console.log("🔔 Cambio materiali rilevato → dirty = true");
    }
    aggiornaCostoMateriali(materiali);
  }, [materiali, materialiOpzionali, materialiPrezzoACorpo, prezzoMaterialiManuale]);

  useEffect(() => {
    if (!isOpen) return;

    console.log("📄 Modal aperto, modalità:", modalMode);
    console.log("📄 Stato sconto:", { tipoSconto, scontoPercentuale, scontoImporto });
    console.log("📄 Stato IVA:", { escludiIva, ivaPercentuale });
    console.log("📄 SelectedPreventivo:", selectedPreventivo);

    setIsDirty(false);
    setIsLoadingModal(true);

    if (modalMode === "create" || !selectedPreventivo) {
      setTitoloCliente("");
      setCliente("");
      setIndirizzo("");
      setEmail("");
      setTelefono("");
      setCodiceFiscale("");
      setPartitaIva("");
      setClienteId(null);
      setSitiCliente([]);
      setSitoClienteId("");
      setDataEmissione(new Date().toLocaleDateString("fr-CA"));
      setValidita("30");
      setDataScadenza("");
      setOggetto("");
      setDescrizione("");
      setDescrizioneRich("");
      setCostoMateriali(0);
      setMaterialiPrezzoACorpo(false);
      setPrezzoMaterialiManuale("");
      setCostoManodopera(0);
      setOreLavoro(0);
      setCostoOrario(0);
      setCostiAggiuntivi(0);
      setCostoTotale(0);
      setCostoTotaleSenzaSconto(0);
      setIvaPercentuale(22);
      setCostoTotaleConIva(0);
      setScontoPercentuale(0);
      setScontoImporto(0);
      setTipoSconto("percentuale");
      setCondizioniPagamento("");
      setTempiEsecuzione("");
      setGaranzia("");
      setNote("");
      setStato("Da fare");
      setMateriali([]);
      setMaterialiOpzionali([]);
      setAllegati([]);
      setMaterialeSelezionato(null);
      setMaterialeOpzionaleSelezionato(null);
      setQuantitaMateriale(0);
      setMaterialiSelezionatiMultipli({});
      setQuantitaMaterialeOpzionale(1);
      setCostiAggiuntiviDettaglio(emptyCostiAggiuntiviDettaglio());
      setCostiAggiuntivi(0);
      setEscludiIva(false);
      setIvaSoloMateriali(false);
      setArrotondaTotaleDifetto(true);
      setArrotondamentoCommerciale(0);
      setIsLoadingModal(false);
      // reset anche lo snapshot
      initialMaterialsSnapshotRef.current = serializeMaterials([]);
    } else {
      const loadData = async () => {
        await fetchPreventivoMateriali(selectedPreventivo.id);
      };
      loadData();
    }

    fetchMaterialiDisponibili();
  }, [isOpen, modalMode, selectedPreventivo]);

  const fetchMaterialiDisponibili = async () => {
    try {
      const response = await fetch(`${API_URL}/materiali`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      if (!response.ok) throw new Error("Errore nel recupero dei materiali");
      const data = await response.json();
      setMaterialiDisponibili(data);
    } catch (error) {
      console.error("❌ Errore nel recupero dei materiali:", error);
      toast.error("Errore nel caricamento dei materiali disponibili!");
    }
  };

  const toggleMaterialeMultiplo = (materiale) => {
    const id = String(materiale.id);

    setMaterialiSelezionatiMultipli((prev) => {
      if (Object.prototype.hasOwnProperty.call(prev, id)) {
        const next = { ...prev };
        delete next[id];
        return next;
      }

      return { ...prev, [id]: 1 };
    });
  };

  const aggiornaQuantitaMaterialeMultiplo = (materialeId, quantita) => {
    const id = String(materialeId);
    const valore = Math.max(1, parseInt(quantita, 10) || 1);

    setMaterialiSelezionatiMultipli((prev) => ({
      ...prev,
      [id]: valore,
    }));
  };

  const handleAddMaterialiMultipli = () => {
    const selezionati = Object.entries(materialiSelezionatiMultipli);

    if (selezionati.length === 0) {
      toast.error("Seleziona almeno un materiale!");
      return;
    }

    const chiaviEsistenti = new Set(
      materiali.map(
        (m) => `${m.codiceMateriale || ""}|||${m.descrizioneMateriale || ""}`
      )
    );

    const nuoviMateriali = selezionati
      .map(([id, quantita]) => {
        const materiale = materialiDisponibili.find(
          (m) => String(m.id) === String(id)
        );
        if (!materiale) return null;

        const chiave = `${materiale.codiceMateriale || ""}|||${materiale.descrizioneMateriale || ""}`;
        if (chiaviEsistenti.has(chiave)) return null;

        const qta = Math.max(1, parseInt(quantita, 10) || 1);
        const costoUnitario = getPrezzoMateriale(materiale);
        chiaviEsistenti.add(chiave);

        return {
          codiceMateriale: materiale.codiceMateriale,
          descrizioneMateriale: materiale.descrizioneMateriale,
          quantita: qta,
          costoUnitario: costoUnitario.toFixed(2),
          costoTotaleMateriale: (qta * costoUnitario).toFixed(2),
          thumbnail: materiale.thumbnail || null,
        };
      })
      .filter(Boolean);

    if (nuoviMateriali.length === 0) {
      toast.warn("I materiali selezionati sono già presenti nel preventivo.");
      setMaterialiSelezionatiMultipli({});
      return;
    }

    const updatedMateriali = [...materiali, ...nuoviMateriali];

    setMateriali(updatedMateriali);
    aggiornaCostoMateriali(updatedMateriali);
    setMaterialiSelezionatiMultipli({});
    setIsDirty(true);

    toast.success(
      `✅ ${nuoviMateriali.length} ${
        nuoviMateriali.length === 1 ? "materiale aggiunto" : "materiali aggiunti"
      }!`
    );
  };

  const aggiornaCostoMateriali = (materialiArr) => {
    // BETALUMINA_MATERIALI_A_CORPO_CALC_FIX13D
    if (materialiPrezzoACorpo) {
      const manuale = Number.parseFloat(
        String(prezzoMaterialiManuale || "").replace(",", ".")
      );
      setCostoMateriali(Number.isFinite(manuale) ? manuale : 0);
      return;
    }

    const totale = materialiArr.reduce((acc, materiale) => {
      const quantita = parseInt(materiale.quantita, 10) || 0;
      const costoUnitario = parseFloat(materiale.costoUnitario) || 0;
      return acc + quantita * costoUnitario;
    }, 0);
    setCostoMateriali(totale);
    console.log("📊 Costo materiali aggiornato nel modal:", totale);
  };

  const handleEditMateriale = (index) => {
    const materiale = materiali[index];
    setMaterialeSelezionato({ ...materiale });
    setQuantitaMateriale(materiale.quantita);
    setEditingMaterialeIndex(index);
    setIsDirty(true);
    setTimeout(() => {
      quantitaInputRef.current?.focus();
    }, 100);
  };

  const handleAddMateriale = () => {
    if (!materialeSelezionato || quantitaMateriale <= 0) {
      toast.error("Seleziona un materiale e specifica una quantità valida!");
      return;
    }

    const nuovoMateriale = {
      codiceMateriale: materialeSelezionato.codiceMateriale,
      descrizioneMateriale: materialeSelezionato.descrizioneMateriale,
      quantita: parseInt(quantitaMateriale, 10),
      costoUnitario: parseFloat(materialeSelezionato.costoUnitario) || 0,
      costoTotaleMateriale: (
        (parseInt(quantitaMateriale, 10) || 0) *
        (parseFloat(materialeSelezionato.costoUnitario) || 0)
      ).toFixed(2),
      thumbnail: materialeSelezionato.thumbnail || null,
    };

    let updatedMateriali;
    if (editingMaterialeIndex !== null) {
      updatedMateriali = materiali.map((m, i) =>
        i === editingMaterialeIndex ? nuovoMateriale : m
      );
      toast.success("Materiale aggiornato!");
      setEditingMaterialeIndex(null);
    } else {
      const exists = materiali.some(
        (m) =>
          m.codiceMateriale === nuovoMateriale.codiceMateriale &&
          m.descrizioneMateriale === nuovoMateriale.descrizioneMateriale
      );
      if (exists) {
        toast.error("Materiale già aggiunto!");
        return;
      }
      updatedMateriali = [...materiali, nuovoMateriale];
      toast.success("Materiale aggiunto!");
    }

    setMateriali(updatedMateriali);
    aggiornaCostoMateriali(updatedMateriali);
    setIsDirty(true);
    setMaterialeSelezionato(null);
    setQuantitaMateriale(0);
  };

  // BETALUMINA_PREVENTIVI_EDIT_UNIT_PRICE_FIX14_20261012
  const parsePrezzoMateriale = (value) => {
    const parsed = Number.parseFloat(
      String(value ?? "").trim().replace(",", ".")
    );
    return Number.isFinite(parsed) && parsed >= 0 ? parsed : 0;
  };

  const aggiornaPrezzoMaterialeRiga = (index, rawValue, opzionale = false) => {
    const setter = opzionale ? setMaterialiOpzionali : setMateriali;

    setter((prev) =>
      prev.map((materiale, i) => {
        if (i !== index) return materiale;

        const prezzo = parsePrezzoMateriale(rawValue);
        const qta = Number.parseFloat(materiale.quantita) || 0;

        return {
          ...materiale,
          costoUnitario: rawValue,
          costoTotaleMateriale: (qta * prezzo).toFixed(2),
        };
      })
    );

    setIsDirty(true);
  };

  const normalizzaPrezzoMaterialeRiga = (index, rawValue, opzionale = false) => {
    const prezzo = parsePrezzoMateriale(rawValue);
    aggiornaPrezzoMaterialeRiga(index, prezzo.toFixed(2), opzionale);
  };

  const handleRemoveMateriale = (index) => {
    console.log("🧹 handleRemoveMateriale index:", index);
    const updatedMateriali = materiali.filter((_, i) => i !== index);
    setMateriali(updatedMateriali);
    aggiornaCostoMateriali(updatedMateriali);
    setIsDirty(true);
    toast.success("Materiale rimosso!");
  };

  const handleAllegatiChange = (e) => {
    const files = Array.from(e.target.files);
    setAllegati([...allegati, ...files]);
    setIsDirty(true);
  };

  const handleRemoveAllegato = async (index) => {
    const allegato = allegati[index];
    if (!allegato) return;

    // File appena selezionato: non esiste ancora nel DB.
    if (!allegato.id) {
      setAllegati((prev) => prev.filter((_, i) => i !== index));
      setIsDirty(true);
      toast.success("Allegato rimosso dalla selezione.");
      return;
    }

    const preventivoId = selectedPreventivo?.id;
    if (!preventivoId) {
      toast.error("Impossibile identificare il preventivo.");
      return;
    }

    const nome =
      allegato.name ||
      allegato.descrizione ||
      (allegato.url ? String(allegato.url).split("/").pop() : "allegato");

    if (!window.confirm(`Eliminare definitivamente "${nome}" dal preventivo?`)) {
      return;
    }

    try {
      const response = await fetch(
        `${API_URL}/preventivi/${preventivoId}/allegati/${allegato.id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`DELETE allegato fallita: ${response.status} - ${errorText}`);
      }

      setAllegati((prev) => prev.filter((item) => item.id !== allegato.id));
      toast.success("Allegato eliminato definitivamente.");
    } catch (error) {
      console.error("Errore eliminazione allegato preventivo:", error);
      toast.error("Errore durante l'eliminazione dell'allegato.");
    }
  };

  const handleFieldChange = (setter, field) => (value) => {
    console.log(`📊 Cambio ${field}:`, value);
    setIsDirty(true);

    if (field === "escludiIva") {
      setEscludiIva(value);
      console.log(`📊 IVA esclusa: ${value}`);
      return;
    }

    setter(value);

    if (field === "scontoPercentuale" && tipoSconto === "percentuale") {
      const baseTotale =
        costoMateriali + oreLavoro * costoOrario + costiAggiuntivi;
      const scontoCalcolato = isNaN(parseFloat(value))
        ? 0
        : (baseTotale * parseFloat(value)) / 100;
      setScontoImporto(scontoCalcolato.toFixed(2));
      console.log(`📊 Sconto percentuale: ${value}% = ${scontoCalcolato} €`);
    } else if (field === "scontoImporto" && tipoSconto === "fisso") {
      const baseTotale =
        costoMateriali + oreLavoro * costoOrario + costiAggiuntivi;
      const scontoVal = isNaN(parseFloat(value)) ? 0 : parseFloat(value);
      setScontoPercentuale(
        baseTotale > 0 ? ((scontoVal / baseTotale) * 100).toFixed(2) : 0
      );
      console.log(`📊 Sconto fisso: ${scontoVal} €`);
    }
  };

  const handleSave = async () => {
  const currentSnap = serializeMaterials([
    ...materiali.map((m) => ({ ...m, is_aggiuntivo: 0 })),
    ...materialiOpzionali.map((m) => ({ ...m, is_aggiuntivo: 1 })),
  ]);
    const materialsChanged = currentSnap !== initialMaterialsSnapshotRef.current;

    if (!isDirty && !materialsChanged) {
      console.log("📄 Nessuna modifica, salvataggio non necessario");
      onClose();
      return;
    }
    console.log("💾 Si salva perché:", { isDirty, materialsChanged });

    const costoManodoperaCalc = oreLavoro * costoOrario;
    const baseTotale = costoMateriali + costoManodoperaCalc + costiAggiuntivi;
    const scontoEuro =
      tipoSconto === "fisso"
        ? parseFloat(scontoImporto) || 0
        : (baseTotale * parseFloat(scontoPercentuale || 0)) / 100 || 0;
    const totaleScontato = Math.max(baseTotale - scontoEuro, 0);
    const ivaPerc = parseFloat(ivaPercentuale || 0);

// Calcolo base IVA corretta
const quotaMaterialiSulTotale =
  baseTotale > 0 ? Math.min(costoMateriali / baseTotale, 1) : 0;

const scontoSuMateriali = scontoEuro * quotaMaterialiSulTotale;

const baseIvaMateriali = Math.min(
  Math.max(costoMateriali - scontoSuMateriali, 0),
  totaleScontato
);

let baseIva = 0;

if (escludiIva) {
  baseIva = 0;
} else if (ivaSoloMateriali) {
  baseIva = baseIvaMateriali;
} else {
  baseIva = totaleScontato;
}

const ivaImporto = (baseIva * ivaPerc) / 100;
const totaleConIvaPreciso = Number(
      (totaleScontato + ivaImporto).toFixed(2)
    );
    const totaleConIva = totaleConIvaPreciso > 0
      ? Math.round((totaleConIvaPreciso + Number.EPSILON) / 5) * 5
      : 0;
    const arrotondamentoCommercialeCalcolato = Number(
      (totaleConIva - totaleConIvaPreciso).toFixed(2)
    );

    // unifica materiali inclusi (is_aggiuntivo=0) + opzionali (is_aggiuntivo=1)
    const ufficiali = (materiali || []).map((m) => ({ ...m, is_aggiuntivo: 0 }));
    const extra = (materialiOpzionali || []).map((m) => ({
      ...m,
      is_aggiuntivo: 1,
    }));
    const payloadMateriali = [...ufficiali, ...extra];
    console.log("📄 Payload materiali inviato:", payloadMateriali);

    if (
      dataScadenza &&
      dataEmissione &&
      dataScadenza < dataEmissione
    ) {
      toast.error("La scadenza non può precedere la data di emissione.");
      return;
    }

    if (materialiPrezzoACorpo) {
      const prezzoManuale = Number.parseFloat(
        String(prezzoMaterialiManuale || "").replace(",", ".")
      );

      if (!Number.isFinite(prezzoManuale) || prezzoManuale < 0) {
        toast.error("Inserire un prezzo materiali a corpo valido.");
        return;
      }
    }

    const preventivoData = {
      cliente_id: clienteId || "",
      sito_id: sitoClienteId || "",
      cliente,
      titoloCliente,
      indirizzo,
      email,
      telefono,
      codiceFiscale,
      partitaIva,
      dataEmissione,
      validita,
      dataScadenza: dataScadenza || "",
      oggetto: normalizeText(oggetto),
      descrizione: normalizeText(descrizione),
      descrizioneRich,
      costoMateriali,
      materialiPrezzoACorpo: toFlag(materialiPrezzoACorpo),
      prezzoMaterialiManuale: materialiPrezzoACorpo
        ? String(prezzoMaterialiManuale || "").replace(",", ".")
        : "",
      costoManodopera: costoManodoperaCalc,
      oreLavoro,
      costoOrario,
      costiAggiuntivi,
      costiAggiuntiviDettaglio: JSON.stringify(costiAggiuntiviDettaglio),
      costoTotale: baseTotale,
      costoTotaleScontato: totaleScontato,
      ivaPercentuale,
      costoTotaleConIva: totaleConIva,
      scontoPercentuale,
      scontoImporto,
      condizioniPagamento,
      tempiEsecuzione,
      garanzia,
      note: normalizeText(note),
      stato,
      materiali: JSON.stringify(payloadMateriali), // <-- unificati con flag
      escludiIva: toFlag(escludiIva),
      ivaSoloMateriali: toFlag(ivaSoloMateriali),
      arrotondaTotaleDifetto: 1,
    };

    const formData = new FormData();
    for (const key in preventivoData) {
      formData.append(key, preventivoData[key]);
    }
    // BETALUMINA_PREVENTIVI_ALLEGATI_ONLY_NEW_FILES_FIX5_20260928
    allegati.forEach((file) => {
      if (typeof File !== "undefined" && file instanceof File) {
        formData.append("allegati", file);
      }
    });

    try {
      const response = await fetch(
        `${API_URL}/preventivi${
          modalMode === "edit" && selectedPreventivo ? `/${selectedPreventivo.id}` : ""
        }`,
        {
          method: modalMode === "create" ? "POST" : "PUT",
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
          body: formData,
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Errore nella richiesta: ${response.status} - ${errorText}`);
      }

      const result = await response.json();
      console.log("📄 Risposta dal backend:", result);
      toast.success(
        modalMode === "create" ? "✅ Preventivo creato!" : "✅ Preventivo aggiornato!"
      );
      onSave(result);
      onClose();
    } catch (error) {
      console.error("❌ Errore durante il salvataggio:", error);
      toast.error(`Errore: ${error.message}`);
    }
  };

  useEffect(() => {
    const totale = Number(totaleCostiAggiuntiviDettaglio(costiAggiuntiviDettaglio).toFixed(2));
    setCostiAggiuntivi(totale);
  }, [costiAggiuntiviDettaglio]);

  useEffect(() => {
    if (!isOpen || isLoadingModal) return;

    const costoManodoperaCalc = oreLavoro * costoOrario;
    setCostoManodopera(costoManodoperaCalc);

    const baseTotale = costoMateriali + costoManodoperaCalc + costiAggiuntivi;
    setCostoTotaleSenzaSconto(baseTotale);

    let scontoEuro = 0;
    if (tipoSconto === "fisso") {
      scontoEuro = isNaN(parseFloat(scontoImporto)) ? 0 : parseFloat(scontoImporto);
    } else if (tipoSconto === "percentuale") {
      scontoEuro = isNaN(parseFloat(scontoPercentuale))
        ? 0
        : (baseTotale * parseFloat(scontoPercentuale)) / 100;
      setScontoImporto(scontoEuro.toFixed(2));
    }

    const totaleScontato = Math.max(0, baseTotale - scontoEuro);
    const ivaPerc = parseFloat(ivaPercentuale || 0);

// Calcolo base IVA corretta
const quotaMaterialiSulTotale =
  baseTotale > 0 ? Math.min(costoMateriali / baseTotale, 1) : 0;

const scontoSuMateriali = scontoEuro * quotaMaterialiSulTotale;

const baseIvaMateriali = Math.min(
  Math.max(costoMateriali - scontoSuMateriali, 0),
  totaleScontato
);

let baseIva = 0;

if (escludiIva) {
  baseIva = 0;
} else if (ivaSoloMateriali) {
  baseIva = baseIvaMateriali;
} else {
  baseIva = totaleScontato;
}

const ivaImporto = (baseIva * ivaPerc) / 100;
const totaleConIvaPreciso = Number(
      (totaleScontato + ivaImporto).toFixed(2)
    );
    const totaleConIva = totaleConIvaPreciso > 0
      ? Math.round((totaleConIvaPreciso + Number.EPSILON) / 5) * 5
      : 0;
    const arrotondamentoCommercialeCalcolato = Number(
      (totaleConIva - totaleConIvaPreciso).toFixed(2)
    );
    setArrotondamentoCommerciale(arrotondamentoCommercialeCalcolato);

    setCostoTotale(Number(totaleScontato.toFixed(2)));
    setCostoTotaleConIva(Number(totaleConIva.toFixed(2)));

    console.log("📊 Calcolo IVA nel modal:", {
      costoMateriali,
      costoManodoperaCalc,
      costiAggiuntivi,
      baseTotale,
      scontoEuro,
      totaleScontato,
      ivaPercentuale,
      ivaImporto,
      totaleConIva,
      escludiIva,
    });
  }, [
    isOpen,
    isLoadingModal,
    costoMateriali,
    oreLavoro,
    costoOrario,
    costiAggiuntivi,
    ivaPercentuale,
    scontoPercentuale,
    scontoImporto,
    tipoSconto,
    escludiIva,
    ivaSoloMateriali,
    materiali,
    arrotondaTotaleDifetto,
    ]);


  useEffect(() => {
    if (!isLoadingModal && materiali.length > 0) {
      console.log("📄 Materiali renderizzati:", materiali);
    }
  }, [materiali, isLoadingModal]);

  // BETALUMINA_PREVENTIVI_PRESERVE_CUSTOM_UNIT_PRICE_FIX14B_20261012
  // I prezzi di magazzino vengono applicati SOLTANTO su azione esplicita
  // dell'utente sul checkbox. Il caricamento del catalogo non modifica più
  // i prezzi già salvati nelle righe del preventivo.
  const applicaPrezziMagazzinoSuMateriali = (usaPrezzoIvato) => {
    if (!materialiDisponibili.length) return;

    const prezzoDaMagazzino = (materiale) => {
      const raw = usaPrezzoIvato
        ? (materiale.prezzoConIva ?? materiale.costoUnitario ?? 0)
        : (materiale.prezzoSenzaIva ?? materiale.costoUnitario ?? 0);

      const parsed = Number.parseFloat(raw);
      return Number.isFinite(parsed) ? parsed : 0;
    };

    setMateriali((prev) =>
      prev.map((m) => {
        const originale = materialiDisponibili.find(
          (md) =>
            md.codiceMateriale === m.codiceMateriale &&
            md.descrizioneMateriale === m.descrizioneMateriale
        );

        if (!originale) return m;

        const nuovoPrezzo = prezzoDaMagazzino(originale);
        const qta = Number.parseFloat(m.quantita) || 0;

        return {
          ...m,
          costoUnitario: nuovoPrezzo.toFixed(2),
          costoTotaleMateriale: (qta * nuovoPrezzo).toFixed(2),
        };
      })
    );

    setMaterialiOpzionali((prev) =>
      prev.map((m) => {
        const originale = materialiDisponibili.find(
          (md) =>
            md.codiceMateriale === m.codiceMateriale &&
            md.descrizioneMateriale === m.descrizioneMateriale
        );

        if (!originale) return m;

        const nuovoPrezzo = prezzoDaMagazzino(originale);
        const qta = Number.parseFloat(m.quantita) || 0;

        return {
          ...m,
          costoUnitario: nuovoPrezzo.toFixed(2),
          costoTotaleMateriale: (qta * nuovoPrezzo).toFixed(2),
        };
      })
    );
  };



  const condizioniStandardPagamento = "Il presente preventivo non è vincolante fino ad accettazione. Pagamento: acconto 30% all'accettazione del preventivo, saldo 70% a fine lavori/collaudo, salvo diversi accordi.";
  const condizioniStandardTempi = "Tempi di esecuzione da concordare in base alla disponibilità dei materiali e alla programmazione degli interventi.";
  const condizioniStandardGaranzia = "Garanzia 24 mesi sui materiali, salvo diverse condizioni del produttore. Manodopera garantita per difetti riconducibili all'installazione.";

  const applicaPresetCondizioni = () => {
    if (!presetCondizioni) {
      toast.info("Seleziona prima un preset condizioni.");
      return;
    }

    if (presetCondizioni === "standard") {
      setCondizioniPagamento(condizioniStandardPagamento);
      setTempiEsecuzione((tempiEsecuzione || "").trim() ? tempiEsecuzione : condizioniStandardTempi);
      setGaranzia((garanzia || "").trim() ? garanzia : condizioniStandardGaranzia);
      setValidita((validita || "").toString().trim() ? validita : "30");
    }

    if (presetCondizioni === "pagamento") {
      setCondizioniPagamento(condizioniStandardPagamento);
    }

    if (presetCondizioni === "garanzia") {
      setGaranzia(condizioniStandardGaranzia);
    }

    if (presetCondizioni === "tempi") {
      setTempiEsecuzione(condizioniStandardTempi);
    }

    setIsDirty(true);
    toast.success("Preset applicato. Premi Aggiorna Preventivo prima di scaricare il PDF.");
  };


  const handleDownloadPDFSicuro = () => {
    if (!selectedPreventivo?.id) {
      toast.error("Preventivo non ancora salvato.");
      return;
    }

    if (isDirty) {
      toast.warning("Ci sono modifiche non salvate. Premi prima Aggiorna Preventivo, poi scarica il PDF.");
      return;
    }

    handleDownloadPDF(selectedPreventivo.id);
  };

  if (!isOpen) return null;





  return (
    
    <div className="modal-overlay">
      <div className="modal-container large-modal">
        <h2>{modalMode === "create" ? "Crea Nuovo Preventivo" : "Modifica Preventivo"}</h2>

        {/* ===== Dati Cliente ===== */}
        <div className="modal-section">
          <h3>Dati Cliente</h3>

          <label>Cliente:</label>
          <div style={{ marginBottom: "10px", maxWidth: "180px" }}>
            <label
              htmlFor="preventivo-titolo-cliente"
              style={{ display: "block", marginBottom: "4px", fontWeight: 600 }}
            >
              Titolo cliente
            </label>
            <select
              id="preventivo-titolo-cliente"
              value={titoloCliente}
              onChange={(e) =>
                handleFieldChange(setTitoloCliente, "titoloCliente")(e.target.value)
              }
              style={{ width: "100%" }}
            >
              <option value="">— Nessun titolo —</option>
              <option value="Sig.">Sig.</option>
              <option value="Sig.ra">Sig.ra</option>
            </select>
          </div>
          <ClienteAutocomplete
            cliente={cliente}
            setCliente={(value) => {
              setCliente(value);
              setIsDirty(true);
            }}
            clienteId={clienteId}
            setClienteId={setClienteId}
            indirizzo={indirizzo}
            setIndirizzo={(value) => {
              setIndirizzo(value);
              setIsDirty(true);
            }}
            telefono={telefono}
            setTelefono={(value) => {
              setTelefono(value);
              setIsDirty(true);
            }}
            email={email}
            setEmail={(value) => {
              setEmail(value);
              setIsDirty(true);
            }}
            setCodiceFiscale={(value) => {
              setCodiceFiscale(value);
              setIsDirty(true);
            }}
            setPartitaIva={(value) => {
              setPartitaIva(value);
              setIsDirty(true);
            }}
          />
          {clienteId && (
            <>
              <label>Sito / impianto:</label>
              <select
                value={sitoClienteId}
                onChange={(e) => {
                  const value = e.target.value;
                  setSitoClienteId(value);
                  const sito = sitiCliente.find(
                    (item) => String(item.id) === String(value)
                  );
                  if (sito) {
                    setIndirizzo(sito.indirizzo || "");
                    setIsDirty(true);
                  }
                }}
              >
                <option value="">
                  {sitiCliente.length
                    ? "Seleziona sito / impianto"
                    : "Nessun sito configurato"}
                </option>
                {sitiCliente.map((sito) => (
                  <option key={sito.id} value={sito.id}>
                    {sito.nome} - {sito.indirizzo}
                  </option>
                ))}
              </select>
            </>
          )}

          <label>Indirizzo:</label>
          <input type="text" value={indirizzo} onChange={(e) => handleFieldChange(setIndirizzo, "indirizzo")(e.target.value)} />
          <label>Email:</label>
          <input type="email" value={email} onChange={(e) => handleFieldChange(setEmail, "email")(e.target.value)} />
          <label>Telefono:</label>
          <input type="text" value={telefono} onChange={(e) => handleFieldChange(setTelefono, "telefono")(e.target.value)} />
          <label>Codice Fiscale:</label>
          <input type="text" value={codiceFiscale} onChange={(e) => handleFieldChange(setCodiceFiscale, "codiceFiscale")(e.target.value)} />
          <label>Partita IVA:</label>
          <input type="text" value={partitaIva} onChange={(e) => handleFieldChange(setPartitaIva, "partitaIva")(e.target.value)} />
        </div>

        {/* ===== Dati Preventivo ===== */}
        <div className="modal-section">
          <h3>Dati Preventivo</h3>
          <label>Data Emissione:</label>
          <input type="date" value={dataEmissione} onChange={(e) => handleFieldChange(setDataEmissione, "dataEmissione")(e.target.value)} />
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "minmax(160px, 0.7fr) minmax(220px, 1fr)",
              gap: "14px",
              alignItems: "end",
            }}
          >
            <div>
              <label>Validità (giorni):</label>
              <input
                type="number"
                value={validita}
                min="1"
                onChange={(e) => {
                  handleFieldChange(setValidita, "validita")(e.target.value);
                  if (dataScadenza) setDataScadenza("");
                }}
              />
            </div>

            <div>
              <label>Scadenza precisa:</label>
              <input
                type="date"
                value={dataScadenza}
                min={dataEmissione || undefined}
                onChange={(e) => {
                  const nextDate = e.target.value || "";
                  setDataScadenza(nextDate);

                  if (nextDate && dataEmissione) {
                    const start = new Date(`${dataEmissione}T00:00:00`);
                    const end = new Date(`${nextDate}T00:00:00`);
                    const diffDays = Math.round((end - start) / 86400000);
                    if (diffDays >= 1) setValidita(String(diffDays));
                  }

                  setIsDirty(true);
                }}
              />
            </div>
          </div>

          <div
            style={{
              marginTop: "5px",
              marginBottom: "10px",
              fontSize: "12px",
              color: "#5f6b76",
            }}
          >
            Facoltativa: se impostata, la data precisa prevale sulla validità in giorni.
          </div>
          <label>Oggetto:</label>
          <input type="text" value={oggetto} onChange={(e) => handleFieldChange(setOggetto, "oggetto")(e.target.value)} placeholder="Oggetto del preventivo" />
          <label>Descrizione:</label>
          <RichTextDescriptionEditor
            value={descrizioneRich}
            fallbackText={descrizione}
            onChange={({ rich, plain }) => {
              setDescrizioneRich(rich);
              setDescrizione(plain);
              setIsDirty(true);
            }}
            minHeight={300}
          />
        </div>

        {/* ===== Prezzo materiali a corpo ===== */}
        <div
          className="modal-section"
          style={{
            border: "1px solid #d9e2e8",
            borderRadius: "8px",
            padding: "14px",
            background: "#f8fafb",
          }}
        >
          <h3 style={{ marginTop: 0, marginBottom: "10px" }}>
            Valorizzazione materiali
          </h3>

          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "9px",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            <input
              type="checkbox"
              checked={materialiPrezzoACorpo}
              onChange={(e) => {
                const enabled = e.target.checked;

                if (enabled) {
                  const seed = Number(costoMateriali) || 0;
                  const seedText = seed.toFixed(2);

                  setMaterialiPrezzoACorpo(true);
                  setPrezzoMaterialiManuale(seedText);
                  setCostoMateriali(seed);
                } else {
                  setMaterialiPrezzoACorpo(false);
                  setPrezzoMaterialiManuale("");

                  const calcolato = (materiali || []).reduce((acc, m) => {
                    const qta = Number.parseFloat(m.quantita || 0) || 0;
                    const unit = Number.parseFloat(m.costoUnitario || 0) || 0;
                    return acc + qta * unit;
                  }, 0);

                  setCostoMateriali(Number(calcolato.toFixed(2)));
                }

                setIsDirty(true);
              }}
            />
            Mostra i materiali con prezzo a corpo nel PDF
          </label>

          <div
            style={{
              marginTop: "6px",
              fontSize: "12px",
              color: "#5f6b76",
              lineHeight: 1.4,
            }}
          >
            Descrizioni e quantità restano visibili. Prezzi unitari e totali
            delle singole righe vengono nascosti.
          </div>

          {materialiPrezzoACorpo && (
            <div style={{ marginTop: "12px", maxWidth: "340px" }}>
              <label>Prezzo materiali a corpo (€):</label>
              <input
                type="number"
                min="0"
                step="0.01"
                value={prezzoMaterialiManuale}
                onChange={(e) => {
                  const value = e.target.value;
                  setPrezzoMaterialiManuale(value);

                  const parsed = Number.parseFloat(
                    String(value || "").replace(",", ".")
                  );

                  setCostoMateriali(Number.isFinite(parsed) ? parsed : 0);
                  setIsDirty(true);
                }}
                placeholder="Es. 11134.00"
              />

              <div
                style={{
                  marginTop: "5px",
                  fontSize: "12px",
                  color: "#1f6f43",
                  fontWeight: 600,
                }}
              >
                Questo importo sostituisce la somma automatica dei materiali
                nel totale del preventivo.
              </div>
            </div>
          )}
        </div>

        {/* ===== Materiali inclusi ===== */}
        <div className="modal-section">
          <h3>Materiali</h3>
          <label>Seleziona Materiale:</label>
          <div style={{ marginBottom: "10px" }}>
            <input
              type="text"
              placeholder="Cerca materiale..."
              value={searchMateriale}
              onChange={(e) => handleFieldChange(setSearchMateriale, "searchMateriale")(e.target.value)}
              style={{ width: "100%", padding: "8px" }}
            />
          </div>
          <div
            style={{
              border: "1px solid #d6dee6",
              borderRadius: "8px",
              padding: "12px",
              marginBottom: "14px",
              background: "#f8fafc",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "10px",
                marginBottom: "10px",
                flexWrap: "wrap",
              }}
            >
              <strong>Selezione multipla rapida</strong>
              <span style={{ fontSize: "13px", color: "#5f6b76" }}>
                Selezionati: {Object.keys(materialiSelezionatiMultipli).length}
              </span>
            </div>

            {!searchMateriale.trim() && (
              <div
                style={{
                  padding: "10px 12px",
                  marginBottom: "10px",
                  borderRadius: "6px",
                  background: "#fff",
                  color: "#64748b",
                  fontSize: "13px",
                }}
              >
                Digita nel campo ?Cerca materiale? per visualizzare e selezionare i risultati.
              </div>
            )}

            <div
              style={{
                display: searchMateriale.trim() ? "block" : "none",
                maxHeight: "320px",
                overflowY: "auto",
                border: "1px solid #e2e8f0",
                borderRadius: "6px",
                background: "#fff",
              }}
            >
              {Object.entries(
                materialiDisponibili
                  .filter((m) =>
                    `${m.codiceMateriale || ""} ${m.descrizioneMateriale || ""}`
                      .toLowerCase()
                      .includes(searchMateriale.toLowerCase())
                  )
                  .sort((a, b) => {
                    const categoriaCompare = (a.categoria || "").localeCompare(
                      b.categoria || ""
                    );
                    if (categoriaCompare !== 0) return categoriaCompare;
                    return (a.codiceMateriale || "").localeCompare(
                      b.codiceMateriale || ""
                    );
                  })
                  .reduce((acc, materiale) => {
                    const categoria = materiale.categoria || "Senza Categoria";
                    if (!acc[categoria]) acc[categoria] = [];
                    acc[categoria].push(materiale);
                    return acc;
                  }, {})
              ).map(([categoria, mats]) => (
                <div key={`multi-${categoria}`}>
                  <div
                    style={{
                      padding: "7px 10px",
                      fontWeight: "bold",
                      background: "#eef3f7",
                      borderBottom: "1px solid #dfe7ee",
                    }}
                  >
                    {categoria.charAt(0).toUpperCase() +
                      categoria.slice(1).replace("_", " ")}
                  </div>

                  {mats.map((m) => {
                    const id = String(m.id);
                    const selezionato = Object.prototype.hasOwnProperty.call(
                      materialiSelezionatiMultipli,
                      id
                    );
                    const giaPresente = materiali.some(
                      (item) =>
                        item.codiceMateriale === m.codiceMateriale &&
                        item.descrizioneMateriale === m.descrizioneMateriale
                    );

                    return (
                      <div
                        key={`multi-materiale-${id}`}
                        style={{
                          display: "grid",
                          gridTemplateColumns: "auto minmax(0, 1fr) 90px",
                          alignItems: "center",
                          gap: "10px",
                          padding: "8px 10px",
                          borderBottom: "1px solid #edf1f4",
                          opacity: giaPresente ? 0.55 : 1,
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={selezionato}
                          disabled={giaPresente}
                          onChange={() => toggleMaterialeMultiplo(m)}
                          aria-label={`Seleziona ${m.codiceMateriale || "materiale"}`}
                        />

                        <div style={{ minWidth: 0 }}>
                          <div style={{ fontWeight: 600 }}>
                            {m.codiceMateriale} - {m.descrizioneMateriale}
                          </div>
                          <div style={{ fontSize: "12px", color: "#64748b" }}>
                            € {getPrezzoMateriale(m).toFixed(2)}
                            {giaPresente ? " · già presente" : ""}
                          </div>
                        </div>

                        {selezionato ? (
                          <input
                            type="number"
                            min="1"
                            value={materialiSelezionatiMultipli[id]}
                            onChange={(e) =>
                              aggiornaQuantitaMaterialeMultiplo(id, e.target.value)
                            }
                            aria-label={`Quantità ${m.codiceMateriale || "materiale"}`}
                            style={{
                              width: "82px",
                              padding: "6px",
                              textAlign: "center",
                            }}
                          />
                        ) : (
                          <span style={{ fontSize: "12px", color: "#94a3b8" }}>
                            Q.tà
                          </span>
                        )}
                      </div>
                    );
                  })}
                </div>
              ))}

              {materialiDisponibili.filter((m) =>
                `${m.codiceMateriale || ""} ${m.descrizioneMateriale || ""}`
                  .toLowerCase()
                  .includes(searchMateriale.toLowerCase())
              ).length === 0 && (
                <div style={{ padding: "14px", color: "#64748b" }}>
                  Nessun materiale trovato.
                </div>
              )}
            </div>

            <button
              type="button"
              onClick={handleAddMaterialiMultipli}
              disabled={Object.keys(materialiSelezionatiMultipli).length === 0}
              style={{ marginTop: "10px" }}
            >
              {Object.keys(materialiSelezionatiMultipli).length === 1
                ? "Aggiungi materiale selezionato"
                : Object.keys(materialiSelezionatiMultipli).length > 1
                ? `Aggiungi ${Object.keys(materialiSelezionatiMultipli).length} materiali selezionati`
                : "Aggiungi materiali selezionati"}
            </button>
          </div>

          {editingMaterialeIndex !== null && materialeSelezionato && (
            <div
              style={{
                marginTop: "14px",
                marginBottom: "14px",
                padding: "12px",
                border: "1px solid #cbd5e1",
                borderRadius: "8px",
                background: "#f8fafc",
              }}
            >
              <div style={{ marginBottom: "8px", color: "#475569" }}>
                Modifica materiale:
                <strong style={{ marginLeft: "6px", color: "#1f2937" }}>
                  {materialeSelezionato.codiceMateriale} - {materialeSelezionato.descrizioneMateriale}
                </strong>
              </div>

              <label>Quantit?:</label>
              <input
                type="number"
                value={quantitaMateriale}
                onChange={(e) =>
                  handleFieldChange(setQuantitaMateriale, "quantitaMateriale")(
                    parseInt(e.target.value) || 0
                  )
                }
                min="1"
                ref={quantitaInputRef}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && quantitaMateriale > 0) {
                    e.preventDefault();
                    handleAddMateriale();
                  }
                }}
              />

              {quantitaMateriale > 0 && (
                <div style={{ marginTop: "10px", fontWeight: "bold" }}>
                  Costo totale: {(
                    quantitaMateriale *
                    (parseFloat(materialeSelezionato.costoUnitario) || 0)
                  ).toFixed(2)} ?
                </div>
              )}

              <button
                type="button"
                onClick={handleAddMateriale}
                disabled={quantitaMateriale <= 0}
              >
                Salva modifica
              </button>
            </div>
          )}

          {materiali.length > 0 && !isLoadingModal ? (
            <div className="preventivo-materiali-table-container">
              <table className="preventivo-materiali-table">
                <thead>
                  <tr>
                    <th>Codice</th>
                    <th>Descrizione</th>
                    <th>Q.tà</th>
                    <th>Costo Unitario (€)</th>
                    <th>Costo Totale (€)</th>
                    <th>Azioni</th>
                  </tr>
                </thead>
                <tbody>
                  {materiali.map((materiale, index) => (
                    <tr key={index}>
                      <td>{materiale.codiceMateriale || "N/D"}</td>
                      <td>{materiale.descrizioneMateriale || "N/D"}</td>
                      <td>{materiale.quantita}</td>
                      <td style={{ minWidth: "118px" }}>
                        <input
                          type="text"
                          inputMode="decimal"
                          value={materiale.costoUnitario ?? ""}
                          onChange={(e) =>
                            aggiornaPrezzoMaterialeRiga(
                              index,
                              e.target.value,
                              false
                            )
                          }
                          onBlur={(e) =>
                            normalizzaPrezzoMaterialeRiga(
                              index,
                              e.target.value,
                              false
                            )
                          }
                          aria-label={`Prezzo unitario ${materiale.codiceMateriale || index + 1}`}
                          style={{
                            width: "100px",
                            textAlign: "right",
                            padding: "6px 7px",
                            border: "1px solid #b8c2cc",
                            borderRadius: "5px",
                            background: "#fff",
                          }}
                        />
                      </td>
                      <td>{materiale.costoTotaleMateriale}</td>
                      <td>
                        <button
                          type="button"
                          onClick={() => handleEditMateriale(index)}
                          className="edit-btn"
                          style={{ marginRight: "8px", backgroundColor: "#007bff", color: "#fff", border: "none", padding: "5px 10px", borderRadius: "4px" }}
                        >
                          Modifica
                        </button>
                        <button
                          type="button"
                          onClick={() => handleRemoveMateriale(index)}
                          className="delete-btn"
                          style={{ backgroundColor: "#dc3545", color: "#fff", border: "none", padding: "5px 10px", borderRadius: "4px" }}
                        >
                          Rimuovi
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : isLoadingModal ? (
            <div>Caricamento materiali...</div>
          ) : null}
        </div>

        {/* ===== Materiali Opzionali ===== */}
        {/* BETALUMINA_OPTIONAL_MATERIAL_SEARCH_R1 */}
        <div className="modal-section">
          <h3>Materiali Opzionali (fuori preventivo)</h3>

          <label>Seleziona Materiale:</label>

          <div
            style={{
              border: "1px solid #d6dee6",
              borderRadius: "10px",
              padding: "12px",
              marginBottom: "14px",
              background: "#f8fafc",
            }}
          >
            <input
              type="search"
              placeholder="Cerca materiale..."
              value={searchMaterialeOpzionale}
              onChange={(e) => setSearchMaterialeOpzionale(e.target.value)}
              autoComplete="off"
              style={{
                width: "100%",
                padding: "9px 10px",
                border: "1px solid #ccd6e0",
                borderRadius: "8px",
                boxSizing: "border-box",
                marginBottom: "10px",
              }}
            />

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "10px",
                marginBottom: "10px",
                flexWrap: "wrap",
              }}
            >
              <strong>Selezione multipla rapida</strong>
              <span style={{ fontSize: "13px", color: "#5f6b76" }}>
                Selezionati: {Object.keys(materialiOpzionaliSelezionatiMultipli).length}
              </span>
            </div>

            {queryOpzionaleR2.length < 2 ? (
              <div style={{ padding: "10px", borderRadius: "7px", background: "#fff", color: "#657384", fontSize: "13px" }}>
                Digita almeno 2 caratteri per visualizzare i materiali.
              </div>
            ) : materialiOpzionaliRisultatiR2.length === 0 ? (
              <div style={{ padding: "10px", borderRadius: "7px", background: "#fff", color: "#657384", fontSize: "13px" }}>
                Nessun materiale trovato.
              </div>
            ) : (
              <div style={{ maxHeight: "360px", overflowY: "auto", background: "#fff", border: "1px solid #e1e7ed", borderRadius: "8px" }}>
                {materialiOpzionaliRisultatiR2.slice(0, 40).map((m) => {
                  const id = String(m.id);
                  const selezionato = Object.prototype.hasOwnProperty.call(materialiOpzionaliSelezionatiMultipli, id);
                  const giaPresente = materialiOpzionali.some(
                    (x) =>
                      x.codiceMateriale === m.codiceMateriale &&
                      x.descrizioneMateriale === m.descrizioneMateriale
                  );
                  const prezzo = getPrezzoMateriale(m);

                  return (
                    <div
                      key={m.id}
                      style={{
                        display: "grid",
                        gridTemplateColumns: "34px minmax(95px, 0.7fr) minmax(0, 3fr) 95px 82px",
                        gap: "10px",
                        alignItems: "center",
                        padding: "9px 10px",
                        borderBottom: "1px solid #edf1f5",
                        opacity: giaPresente ? 0.5 : 1,
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={selezionato}
                        disabled={giaPresente}
                        onChange={() => toggleMaterialeOpzionaleR2(m)}
                        aria-label={`Seleziona ${m.codiceMateriale || "materiale"}`}
                      />
                      <div>
                        <strong style={{ fontSize: "13px" }}>
                          {m.codiceMateriale || "Senza codice"}
                        </strong>
                        <div style={{ marginTop: "2px", color: "#7b8794", fontSize: "11px" }}>
                          {m.categoria || "Senza categoria"}
                        </div>
                      </div>
                      <div title={m.descrizioneMateriale || ""} style={{ minWidth: 0, fontSize: "13px", lineHeight: 1.35 }}>
                        {m.descrizioneMateriale || "Nessuna descrizione"}
                        {giaPresente && (
                          <div style={{ marginTop: "3px", color: "#9a6700", fontSize: "11px", fontWeight: 600 }}>
                            Già aggiunto agli opzionali
                          </div>
                        )}
                      </div>
                      <div style={{ textAlign: "right", whiteSpace: "nowrap", fontSize: "13px", fontWeight: 600 }}>
                        € {Number(prezzo || 0).toFixed(2)}
                      </div>
                      <input
                        type="number"
                        min="1"
                        value={selezionato ? materialiOpzionaliSelezionatiMultipli[id] : 1}
                        disabled={!selezionato || giaPresente}
                        onChange={(e) => aggiornaQuantitaMaterialeOpzionaleR2(id, e.target.value)}
                        aria-label={`Quantità ${m.codiceMateriale || "materiale"}`}
                        style={{ width: "72px", padding: "6px", boxSizing: "border-box" }}
                      />
                    </div>
                  );
                })}
              </div>
            )}

            {materialiOpzionaliRisultatiR2.length > 40 && (
              <div style={{ marginTop: "7px", fontSize: "12px", color: "#657384" }}>
                Mostrati i primi 40 risultati. Affina la ricerca per restringere l'elenco.
              </div>
            )}

            <div style={{ marginTop: "12px", paddingTop: "12px", borderTop: "1px solid #dfe6ed" }}>
              <label>Gruppo / pacchetto opzionale:</label>
              <input
                type="text"
                list="gruppi-opzione-preventivo"
                placeholder="Es. Sistema comunicazione 4G/LTE completo"
                value={gruppoMaterialeOpzionale}
                onChange={(e) => {
                  const next = e.target.value;
                  setGruppoMaterialeOpzionale(next);
                  const norm = next.trim().toLowerCase();
                  const existing = materialiOpzionali.find(
                    (m) => String(m.opzioneGruppo || "").trim().toLowerCase() === norm
                  );
                  setStornoMaterialeOpzionale(existing ? parseFloat(existing.opzioneStorno) || 0 : 0);
                  setIsDirty(true);
                }}
                style={{ width: "100%", padding: "8px", marginBottom: "6px", boxSizing: "border-box" }}
              />
              <datalist id="gruppi-opzione-preventivo">
                {[...new Set(
                  materialiOpzionali
                    .map((m) => String(m.opzioneGruppo || "").trim())
                    .filter(Boolean)
                )].map((g) => (
                  <option key={g} value={g} />
                ))}
              </datalist>

              <small style={{ display: "block", marginBottom: "10px", color: "#666" }}>
                Il gruppo e lo storno vengono applicati a tutti i materiali selezionati.
              </small>

              <label>Storno del gruppo (€):</label>
              <input
                type="number"
                min="0"
                step="0.01"
                value={stornoMaterialeOpzionale}
                onChange={(e) => {
                  setStornoMaterialeOpzionale(parseFloat(e.target.value) || 0);
                  setIsDirty(true);
                }}
                style={{ width: "100%", padding: "8px", marginBottom: "10px", boxSizing: "border-box" }}
              />

              <button
                type="button"
                onClick={handleAddMaterialiOpzionaliMultipliR2}
                disabled={Object.keys(materialiOpzionaliSelezionatiMultipli).length === 0}
                style={{ width: "100%" }}
              >
                {Object.keys(materialiOpzionaliSelezionatiMultipli).length === 1
                  ? "Aggiungi materiale opzionale selezionato"
                  : Object.keys(materialiOpzionaliSelezionatiMultipli).length > 1
                  ? `Aggiungi ${Object.keys(materialiOpzionaliSelezionatiMultipli).length} materiali opzionali selezionati`
                  : "Aggiungi materiali opzionali selezionati"}
              </button>
            </div>
          </div>

          {materialiOpzionali.length > 0 && (
            <div
              className="preventivo-materiali-table-container"
              style={{ marginTop: "20px" }}
            >
              {/* BETALUMINA_OPTIONAL_TABLE_LAYOUT_R3 */}
              <table className="preventivo-materiali-table">{/* BETALUMINA_OPTIONAL_TABLE_LAYOUT_R3_FIX2 */}
              <thead>
                <tr>
                  <th>Codice</th>
                  <th>Descrizione</th>
                  <th>Q.tà</th>
                  <th>Costo Unitario (€)</th>
                  <th>Costo Totale (€)</th>
                  <th>Azioni</th>
                </tr>
              </thead>
              <tbody>
                {materialiOpzionali.map((m, idx) => (
                  <tr key={idx}>
                    <td>{m.codiceMateriale}</td>
                    <td>
                      <div>{m.descrizioneMateriale}</div>
                      {m.opzioneGruppo && (
                        <div style={{ marginTop: "4px", fontSize: "12px", color: "#8a5a00" }}>
                          Gruppo: <strong>{m.opzioneGruppo}</strong>
                          {(parseFloat(m.opzioneStorno) || 0) > 0 && (
                            <> · Storno gruppo: € {(parseFloat(m.opzioneStorno) || 0).toFixed(2)}</>
                          )}
                        </div>
                      )}
                    </td>
                    <td>{m.quantita}</td>
                    <td style={{ minWidth: "118px" }}>
                      <input
                        type="text"
                        inputMode="decimal"
                        value={m.costoUnitario ?? ""}
                        onChange={(e) =>
                          aggiornaPrezzoMaterialeRiga(
                            idx,
                            e.target.value,
                            true
                          )
                        }
                        onBlur={(e) =>
                          normalizzaPrezzoMaterialeRiga(
                            idx,
                            e.target.value,
                            true
                          )
                        }
                        aria-label={`Prezzo unitario opzionale ${m.codiceMateriale || idx + 1}`}
                        style={{
                          width: "100px",
                          textAlign: "right",
                          padding: "6px 7px",
                          border: "1px solid #b8c2cc",
                          borderRadius: "5px",
                          background: "#fff",
                        }}
                      />
                    </td>
                    <td>{m.costoTotaleMateriale}</td>
                    <td>
                      <button
                        type="button"
                        onClick={() => {
                          setMaterialeOpzionaleSelezionato(m);
                          setQuantitaMaterialeOpzionale(m.quantita);
                          setGruppoMaterialeOpzionale(m.opzioneGruppo || "");
                          setStornoMaterialeOpzionale(parseFloat(m.opzioneStorno) || 0);
                          setMaterialiOpzionali(materialiOpzionali.filter((_, i) => i !== idx));
                          setIsDirty(true);
                        }}
                        className="edit-btn"
                        style={{ marginRight: "8px", backgroundColor: "#007bff", color: "#fff", border: "none", padding: "5px 10px", borderRadius: "4px" }}
                      >
                        Modifica
                      </button>
                      <button
                        type="button"
                        onClick={() => {
                          const updated = materialiOpzionali.filter((_, i) => i !== idx);
                          setMaterialiOpzionali(updated);
                          setIsDirty(true);
                          toast.success("Materiale opzionale rimosso!");
                        }}
                        className="delete-btn"
                        style={{ backgroundColor: "#dc3545", color: "#fff", border: "none", padding: "5px 10px", borderRadius: "4px" }}
                      >
                        Rimuovi
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
          )}
        </div>

        {/* ===== Costi ===== */}
        <div className="modal-section">
          <h3>Costi</h3>
          <label>Costo Materiali (€):</label>
          <input
            type="number"
            value={costoMateriali.toFixed(2)}
            readOnly
            style={{
              padding: "10px",
              fontSize: "16px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              width: "100%",
              height: "40px",
            }}
          />
          <label>Ore di Lavoro:</label>
          <input
            type="number"
            value={oreLavoro}
            onChange={(e) => handleFieldChange(setOreLavoro, "oreLavoro")(parseInt(e.target.value) || 0)}
            min="0"
            style={{
              padding: "10px",
              fontSize: "16px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              width: "100%",
              height: "40px",
            }}
          />
          <label>Costo Orario (€):</label>
          <input
            type="number"
            value={costoOrario}
            onChange={(e) => handleFieldChange(setCostoOrario, "costoOrario")(parseFloat(e.target.value) || 0)}
            min="0"
            step="0.01"
            style={{
              padding: "10px",
              fontSize: "16px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              width: "100%",
              height: "40px",
            }}
          />
          <label>Costo Manodopera (€):</label>
          <input
            type="number"
            value={costoManodopera.toFixed(2)}
            readOnly
            style={{
              padding: "10px",
              fontSize: "16px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              width: "100%",
              height: "40px",
            }}
          />

          {/* BETALUMINA_COSTI_AGGIUNTIVI_DETTAGLIO_UI_R1 */}
          <div
            style={{
              marginTop: "16px",
              padding: "14px",
              border: "1px solid #d6dee6",
              borderRadius: "10px",
              background: "#f8fafc",
            }}
          >
            <h4 style={{ margin: "0 0 6px 0" }}>Costi aggiuntivi dettagliati</h4>
            <small style={{ display: "block", marginBottom: "12px", color: "#66788a" }}>
              Compila solo le voci necessarie. Le voci vuote o pari a zero non verranno stampate nel PDF.
            </small>

            {[
              ["km", "Km trasferta", "number"],
              ["tariffaKm", "Tariffa €/km", "number"],
              ["oreViaggio", "Ore di viaggio", "number"],
              ["tariffaViaggio", "Tariffa viaggio €/h", "number"],
              ["pedaggi", "Pedaggi (€)", "number"],
              ["parcheggi", "Parcheggi (€)", "number"],
              ["spedizioni", "Spedizioni / trasporto materiali (€)", "number"],
              ["noleggi", "Noleggi / mezzi speciali (€)", "number"],
              ["smaltimento", "Smaltimento (€)", "number"],
              ["consumo", "Materiale di consumo (€)", "number"],
            ].map(([field, label, type]) => (
              <div key={field} style={{ display: "grid", gridTemplateColumns: "minmax(180px, 1fr) 160px", gap: "10px", alignItems: "center", marginBottom: "8px" }}>
                <label style={{ margin: 0 }}>{label}:</label>
                <input
                  type={type}
                  min="0"
                  step="0.01"
                  value={costiAggiuntiviDettaglio[field]}
                  onChange={(e) => {
                    setCostiAggiuntiviDettaglio((prev) => ({ ...prev, [field]: e.target.value }));
                    setIsDirty(true);
                  }}
                />
              </div>
            ))}

            <div style={{ display: "grid", gridTemplateColumns: "minmax(180px, 1fr) 160px", gap: "10px", alignItems: "center", marginBottom: "8px" }}>
              <input
                type="text"
                placeholder="Descrizione altro costo"
                value={costiAggiuntiviDettaglio.altroDescrizione}
                onChange={(e) => {
                  setCostiAggiuntiviDettaglio((prev) => ({ ...prev, altroDescrizione: e.target.value }));
                  setIsDirty(true);
                }}
              />
              <input
                type="number"
                min="0"
                step="0.01"
                placeholder="Importo €"
                value={costiAggiuntiviDettaglio.altroImporto}
                onChange={(e) => {
                  setCostiAggiuntiviDettaglio((prev) => ({ ...prev, altroImporto: e.target.value }));
                  setIsDirty(true);
                }}
              />
            </div>

            <div style={{ marginTop: "12px", paddingTop: "10px", borderTop: "1px solid #dfe6ed", fontWeight: 700 }}>
              Totale costi aggiuntivi: € {Number(costiAggiuntivi || 0).toFixed(2)}
            </div>
          </div>
          <label>Tipo di Sconto:</label>
          <select
            value={tipoSconto}
            onChange={(e) => handleFieldChange(setTipoSconto, "tipoSconto")(e.target.value)}
            style={{
              padding: "10px",
              fontSize: "16px",
              border: "2px solid red",
              borderRadius: "4px",
              width: "100%",
              height: "40px",
              visibility: "visible",
              backgroundColor: "#fff",
            }}
          >
            <option value="percentuale">Percentuale (%)</option>
            <option value="fisso">Importo Fisso (€)</option>
          </select>
          <div style={{ display: tipoSconto === "percentuale" ? "block" : "none", marginTop: "10px" }}>
            <label>Sconto (%):</label>
            <input
              type="number"
              value={scontoPercentuale}
              onChange={(e) => handleFieldChange(setScontoPercentuale, "scontoPercentuale")(parseFloat(e.target.value) || 0)}
              min="0"
              max="100"
              step="0.01"
              style={{
                padding: "10px",
                fontSize: "16px",
                border: "2px solid blue",
                borderRadius: "4px",
                width: "100%",
                height: "40px",
                visibility: "visible",
                backgroundColor: "#fff",
              }}
            />
          </div>
          <div style={{ display: tipoSconto === "fisso" ? "block" : "none", marginTop: "10px" }}>
            <label>Sconto (€):</label>
            <input
              type="number"
              value={scontoImporto}
              onChange={(e) => handleFieldChange(setScontoImporto, "scontoImporto")(parseFloat(e.target.value) || 0)}
              min="0"
              step="0.01"
              style={{
                padding: "10px",
                fontSize: "16px",
                border: "2px solid blue",
                borderRadius: "4px",
                width: "100%",
                height: "40px",
                visibility: "visible",
                backgroundColor: "#fff",
              }}
            />
          </div>
          <label>Sconto Applicato (€):</label>
          <input
            type="number"
            value={parseFloat(scontoImporto || 0).toFixed(2)}
            readOnly
            style={{
              padding: "10px",
              fontSize: "16px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              width: "100%",
              height: "40px",
            }}
          />
          <div style={{ margin: "10px 0", display: "flex", alignItems: "center" }}>
  <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
    <input
      type="checkbox"
      checked={materialiIvati}
onChange={(e) => {
  const checked = e.target.checked;
    setMaterialiIvati(checked);
    applicaPrezziMagazzinoSuMateriali(checked);
  setIsDirty(true);
}}
      style={{ width: "20px", height: "20px", marginRight: "8px" }}
    />
    Usa prezzo materiali già ivato da magazzino
  </label>
</div>

<div style={{ margin: "10px 0", display: "flex", alignItems: "center" }}>
  <label className="checkbox-container" style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
    <input
      type="checkbox"
      checked={escludiIva}
      onChange={(e) => {
  const checked = e.target.checked;

  setEscludiIva(checked);

  if (checked) {
    setIvaSoloMateriali(false);
  }

  setIsDirty(true);
}}
      style={{
        width: "20px",
        height: "20px",
        marginRight: "8px",
        cursor: "pointer",
      }}
    />
    Escludi IVA
  </label>
</div>
<div style={{ margin: "10px 0", display: "flex", alignItems: "center" }}>
  <label
    className="checkbox-container"
    style={{
      display: "flex",
      alignItems: "center",
      cursor: escludiIva ? "not-allowed" : "pointer",
opacity: escludiIva ? 0.6 : 1,
    }}
  >
    <input
      type="checkbox"
      checked={ivaSoloMateriali}
      disabled={escludiIva}
      onChange={(e) => {
        setIvaSoloMateriali(e.target.checked);
        setIsDirty(true);
      }}
      style={{
        width: "20px",
        height: "20px",
        marginRight: "8px",
        cursor: escludiIva ? "not-allowed" : "pointer",
      }}
    />
    Applica IVA solo sui materiali
  </label>
</div>
          {!escludiIva && (
            
            <>
              <div
            style={{
              margin: "12px 0",
              padding: "12px 14px",
              border: "1px solid #d9e2e8",
              borderRadius: "8px",
              background: "#f8fafb",
            }}
          >
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: "9px",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              <input
                type="checkbox"
                checked={arrotondaTotaleDifetto}
                onChange={(e) => {
                  setArrotondaTotaleDifetto(e.target.checked);
                  setIsDirty(true);
                }}
              />
              Arrotonda totale per difetto all&apos;euro
            </label>

            <div
              style={{
                marginTop: "5px",
                fontSize: "12px",
                color: "#5f6b76",
              }}
            >
              Il totale finale viene sempre ridotto all&apos;euro intero inferiore.
            </div>

            {arrotondaTotaleDifetto &&
              arrotondamentoCommerciale < -0.0001 && (
                <div
                  style={{
                    marginTop: "6px",
                    fontSize: "13px",
                    fontWeight: 600,
                    color: "#1f6f43",
                  }}
                >
                  Arrotondamento commerciale: - €{" "}
                  {Math.abs(arrotondamentoCommerciale).toFixed(2)}
                </div>
              )}
          </div>

          <label>IVA (%):</label>
              <input
                type="number"
                value={ivaPercentuale}
                onChange={(e) => handleFieldChange(setIvaPercentuale, "ivaPercentuale")(parseFloat(e.target.value) || 22)}
                min="0"
                step="0.01"
                style={{
                  padding: "10px",
                  fontSize: "16px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  width: "100%",
                  height: "40px",
                }}
              />
            </>
          )}
          <label>Costo Totale senza IVA (€):</label>
          <input
            type="number"
            value={costoTotale.toFixed(2)}
            readOnly
            style={{
              padding: "10px",
              fontSize: "16px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              width: "100%",
              height: "40px",
            }}
          />
          <label>Costo Totale con IVA (€):</label>
          <input
            type="number"
            value={costoTotaleConIva.toFixed(2)}
            readOnly
            style={{
              padding: "10px",
              fontSize: "16px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              width: "100%",
              height: "40px",
            }}
          />
        </div>

        {/* ===== Condizioni & altri ===== */}
        <div className="modal-section">
          <h3>Condizioni</h3>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "minmax(260px, 1fr) auto",
              gap: "8px",
              alignItems: "center",
              marginBottom: "8px",
            }}
          >
            <select
              value={presetCondizioni}
              onChange={(e) => setPresetCondizioni(e.target.value)}
              style={{
                padding: "10px 12px",
                fontSize: "15px",
                border: "1px solid #cfd3d7",
                borderRadius: "8px",
                height: "42px",
              }}
            >
              <option value="">Preset condizioni...</option>
              <option value="standard">Consigliato: 30/70 + tempi + garanzia</option>
              <option value="pagamento">Solo pagamento 30/70</option>
              <option value="tempi">Solo tempi standard</option>
              <option value="garanzia">Solo garanzia standard</option>
            </select>
            <button
              type="button"
              onClick={applicaPresetCondizioni}
              className="save-btn"
              disabled={!presetCondizioni}
              style={{
                height: "42px",
                opacity: presetCondizioni ? 1 : 0.55,
                cursor: presetCondizioni ? "pointer" : "not-allowed",
                whiteSpace: "nowrap",
              }}
            >
              Applica preset
            </button>
          </div>
          <small style={{ display: "block", marginBottom: "10px", color: "#666" }}>
            I preset compilano i campi sotto. Dopo l'applicazione premi Aggiorna Preventivo per salvarli nel PDF.
          </small>
          <label>Tempi di Esecuzione:</label>
          <input
            type="text"
            value={tempiEsecuzione}
            onChange={(e) => handleFieldChange(setTempiEsecuzione, "tempiEsecuzione")(e.target.value)}
          />
          <label>Condizioni di Pagamento:</label>
          <textarea
            value={condizioniPagamento}
            onChange={(e) => handleFieldChange(setCondizioniPagamento, "condizioniPagamento")(e.target.value)}
            rows="2"
          />
          <label>Garanzia:</label>
          <textarea
            value={garanzia}
            onChange={(e) => handleFieldChange(setGaranzia, "garanzia")(e.target.value)}
            rows="2"
          />
        </div>

        <div className="modal-section">
          <h3>Allegati</h3>
          <label>Carica Allegati:</label>
          <input type="file" multiple onChange={handleAllegatiChange} />
          {allegati.length > 0 && (
            <ul>
              {allegati.map((allegato, index) => (
                <li key={index}>
                  {allegato.name || allegato.descrizione}{" "}
                  <button type="button" onClick={() => handleRemoveAllegato(index)} className="delete-btn">
                    Rimuovi
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="modal-section">
          <h3>Note</h3>
          <textarea
            value={note}
            onChange={(e) => handleFieldChange(setNote, "note")(e.target.value)}
            rows="3"
          />
        </div>
        {/* BETALUMINA_PREVENTIVI_EMAIL_PROGRAMMATA_FRONT_V1_20261018 */}
        <PreventivoEmailSection
          preventivoId={selectedPreventivo?.id || null}
          destinatario={email}
          cliente={cliente}
          isDirty={isDirty}
        />


        <div className="modal-section">
          <label>Stato:</label>
          <select value={stato} onChange={(e) => handleFieldChange(setStato, "stato")(e.target.value)}>
            <option value="Da fare">Da fare</option>
            <option value="In corso">In corso</option>
            <option value="Completato">Completato</option>
          </select>
        </div>

        <div className="modal-buttons">
          {selectedPreventivo && (
            <button type="button" onClick={handleDownloadPDFSicuro} className="view-btn">
              <FaFileAlt style={{ marginRight: "6px" }} /> Scarica PDF
            </button>
          )}
          <button type="button" onClick={handleSave} className="btn save-btn" disabled={isLoadingModal}>
            <FaSave style={{ marginRight: "6px" }} />
            {modalMode === "create" ? "Salva Preventivo" : "Aggiorna Preventivo"}
          </button>
          <button type="button" onClick={onClose} className="btn cancel-btn">
            <FaTimes style={{ marginRight: "6px" }} /> Annulla
          </button>
        </div>
      </div>
    </div>
  );
};

export default PreventivoModal;
